import { Component, OnInit, inject } from '@angular/core';
import { Observable, takeUntil } from 'rxjs';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PageNames } from 'src/app/configs/page-names.enum';
import {
  GetAllPrivateNumberSendLimitWithPaginationDto,
  GetEnumValuesDto,
} from 'src/app/core/api/models';
import { PrivateNumberSendLimitService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { TextPopoverDirective } from 'src/app/core/directives/text-popover.directive';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';

@Component({
  selector: 'all-private-number-send-limit',
  templateUrl: './all-private-number-send-limit.component.html',
  imports: [
    BaseIndexModule,
    ReactiveFormsModule,
    FormsModule,
    TextPopoverDirective,
  ],
})
export class allPrivateNumberSendLimitComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName = PageNames.allPrivateNumberSendLimit;
  protected currentService = inject(PrivateNumberSendLimitService);
  paginationApiMethodName: string =
    this.currentService
      .privateNumberSendLimitGetAllPrivateNumberSendLimitWithPagination.name;
  auditApiMethodName: string =
    this.currentService
      .privateNumberSendLimitGetPrivateNumberSendLimitAuditWithPagination.name;
  modelWithPagination$: Observable<GetAllPrivateNumberSendLimitWithPaginationDto>;
  items$: Observable<Array<GetAllPrivateNumberSendLimitWithPaginationDto>>;
  SmsCpEnumValues: GetEnumValuesDto[] = [];

  //#endregion

  constructor() {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      this.pageConfig.showAddBtn = false;
      this.pageConfig.showHelpBtn = true;
      this.pageConfig.tableConfig.showOperationColumn = false;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  getEnumsValues() {
    this.getEnumValuesApi('SmsCp')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.SmsCpEnumValues = values));
  }

  configTableColumns() {
    this.tableColumns = [
      { title: 'common.userName', name: 'UserName', hasSearch: true },
      {
        title: `${this.tableVocabs}privateNumber`,
        name: 'PrivateNumber',
        hasSearch: true,
        dir: 'ltr',
      },
      {
        title: 'common.organizationName',
        name: 'OrganizationName',
        hasSearch: true,
      },
      {
        title: 'common.smsCp',
        name: 'smsCp',
        hasSearch: true,
        type: 'enum',
        enumName: 'SmsCp',
      },

      {
        title: `${this.tableVocabs}sendTypesList`,
        name: 'sendTypesList',
        noSorting: true,
      },
      {
        title: `${this.tableVocabs}canSeeReceivedSms`,
        name: 'canSeeReceivedSms',
        type: 'boolean',
        hasSearch: true,
      },
      {
        title: 'common.sendToBlackList',
        name: 'sendToBlackList',
        type: 'boolean',
        hasSearch: true,
      },
    ];
  }

  //#region initial methods

  setDefaultTableSort() {}

  //#endregion
}
